import React from "react";
import { Modal } from "antd";

import { i18, trb } from "@utilities";

import "./ExtraCheckModal.less";

export const ExtraCheckModal = ({ onClose, onConfirm, formData, isLoading }) => {
  return (
    <Modal
      onOk={onConfirm}
      visible
      onCancel={onClose}
      okText={trb(i18.Labels.CheckModalOk)}
      cancelText={trb(i18.Labels.CheckModalCancel)}
      title={trb(i18.Labels.CheckModalTitle)}
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <ul className="extra-check-modal">
        <div className="extra-check-modal__title">
          {formData.clientEmail && trb(i18.Labels.ClientProfile)}
        </div>
        {formData.clientEmail && (
          <li>
            {trb(i18.Labels.ClientEmail)} - <b>{formData.clientEmail}</b>
          </li>
        )}
        {formData.clientPhoneNo && (
          <li>
            {trb(i18.Labels.PhoneNumber)} - <b>{formData.clientPhoneNo}</b>
          </li>
        )}
        {formData.addressCountry && (
          <li>
            {trb(i18.Labels.AddressCountry)} - <b>{formData.addressCountry}</b>
          </li>
        )}
        {formData.addressCity && (
          <li>
            {trb(i18.Labels.AddressCity)} - <b>{formData.addressCity}</b>
          </li>
        )}
        {formData.addressStreet && (
          <li>
            {trb(i18.Labels.AddressStreet)} - <b>{formData.addressStreet}</b>
          </li>
        )}

        <div className="extra-check-modal__title">
          {formData.clientCeoSurname && trb(i18.Labels.ClientCeo)}
        </div>
        {formData.clientCeoName && (
          <li>
            {trb(i18.Labels.ClientCeoName)} - <b>{formData.clientCeoName}</b>
          </li>
        )}
        {formData.clientCeoSurname && (
          <li>
            {trb(i18.Labels.ClientCeoSurname)} - <b>{formData.clientCeoSurname}</b>
          </li>
        )}
        {formData.clientCeoPhone && (
          <li>
            {trb(i18.Labels.PhoneNumber)} - <b>{formData.clientCeoPhone}</b>
          </li>
        )}

        <div className="extra-check-modal__title">
          {formData.clientRepSurname && trb(i18.Labels.ClientRep)}
        </div>
        {formData.clientRepName && (
          <li>
            {trb(i18.Labels.ClientRepName)} - <b>{formData.clientRepName}</b>
          </li>
        )}
        {formData.clientRepSurname && (
          <li>
            {trb(i18.Labels.ClientRepSurname)} - <b>{formData.clientRepSurname}</b>
          </li>
        )}
        {formData.clientRepPhoneNo && (
          <li>
            {trb(i18.Labels.PhoneNumber)} - <b>{formData.clientRepPhoneNo}</b>
          </li>
        )}
      </ul>
    </Modal>
  );
};
